import { render, staticRenderFns } from "./tx-map.vue?vue&type=template&id=7b53ef50&scoped=true&"
import script from "./tx-map.vue?vue&type=script&lang=js&"
export * from "./tx-map.vue?vue&type=script&lang=js&"
import style0 from "./tx-map.vue?vue&type=style&index=0&id=7b53ef50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b53ef50",
  null
  
)

export default component.exports